import css from 'styled-jsx/css';

const styles = css.global`#emp-garantica-como-fez-contrato{
    overflow: hidden;
}

#emp-garantica-como-fez-contrato .title-contrato{
    color: #444444;
    font-size: 56px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    font-family: 'SantanderHeadline';
}

#emp-garantica-como-fez-contrato .text-contrato{
    color: #444444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    margin: 18px 0 32px 0;
}

#emp-garantica-como-fez-contrato .row {
    max-width: 1280px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 auto;
    position: relative;
    right: -40px;
}

#emp-garantica-como-fez-contrato .row .box-contrato:nth-child(even) {
    margin: 0 0 88px 40px;
}

#emp-garantica-como-fez-contrato .box-contrato {
    background-color: #F5F9FB;
    font-family: 'SantanderText';
    width: 620px;
    padding: 32px 24px;
    margin-bottom: 88px;
    border-radius: 4px;
    max-width: 620px;
}

#emp-garantica-como-fez-contrato .box-contrato:first-child p {
    max-width: 480px;
}

#emp-garantica-como-fez-contrato .box-contrato:last-child p {
    margin-bottom: 56px;
}

#emp-garantica-como-fez-contrato .box-contrato p{
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#emp-garantica-como-fez-contrato .box-contrato .btn-red {
   width: 272px;
    height: 48px;
    min-width: 88px;
    padding: 12px 16px;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    font-family: "SantanderText";
}

#emp-garantica-como-fez-contrato .box-contrato .btn-white {
    width: 272px;
    height: 48px;
    min-width: 88px;
    padding: 12px 16px;
}

#emp-garantica-como-fez-contrato h4 {
    background-color: #F5F9FB;
    font-family: 'SantanderText';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
    margin-bottom: 16px;
    margin-top: 32px;
}

#emp-garantica-como-fez-contrato p {
    margin-bottom: 32px;
}

@media(max-width: 992px){
    #emp-garantica-como-fez-contrato .row {
        flex-direction: column;
        align-items: center;
        margin: 0 16px;
    }

    #emp-garantica-como-fez-contrato .row {
        right: 0;
    }

    #emp-garantica-como-fez-contrato .box-contrato {
        width: 100%;
        margin: 0 16px 24px 16px;
        /* max-width: 288px; */
    }

    #emp-garantica-como-fez-contrato p {
        margin-bottom: 32px!important;
    }

    #emp-garantica-como-fez-contrato .row .box-contrato:nth-child(even) {
        margin: 0;
    }

    #emp-garantica-como-fez-contrato .row .box-contrato:last-child {
        margin: 0 16px 88px;
    }

    #emp-garantica-como-fez-contrato .title-contrato{
        font-size: 32px;
    }
    #emp-garantica-como-fez-contrato .box-contrato .btn-red {
        height: 48px;
        min-width: 88px;
        padding: 12px 16px;
        max-width: 240px;
    }

    #emp-garantica-como-fez-contrato .box-contrato .btn-white {
        height: 48px;
        min-width: 88px;
        padding: 12px 16px;
        max-width: 240px;
    }
}



@media(max-width: 1277px){
    #emp-garantica-como-fez-contrato .box-contrato:last-child p {
        margin-bottom: 32px;
    }
}`;

export default styles;